import "./myhome.css";
import {
  Stack,
  Card,
  Container,
  Typography,
  Box,
  Grid,
  Select,
  MenuItem,
  FormControl,
  Snackbar,
  Chip,
  alpha,
  Modal,
  Checkbox,
  Button,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import {
  PaymentsRounded,
  LocalShipping,
  ContactPhone,
  EventSeat,
  MonetizationOn,
  AddLocationAlt,
  FactCheck,
  Contacts,
  Handyman,
  Forum,
  AddReactionOutlined,
  Done,
  AutoStories,
  DomainAdd,
  Description,
  Assignment
} from "@mui/icons-material";
import { ReactComponent as EquipmentIcon } from "../assets/images/logo/equipment.svg";
import { ReactComponent as ReportDefectIcon } from "../assets/images/logo/reportDefect.svg";
import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SET_HOUSE_INFO, ProfileContext } from "../contexts/ProfileContext";
import { SET_DISCLAIMER, DisclaimerContext } from "../contexts/DisclaimerContext.js";
import * as dict from "../dictionary/Myhome.js";
import * as api from "../api";
import MasterPage from "../ui-component/MasterPage";
import { useTheme } from "@mui/material/styles";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { checkProductType } from "../utils/checkProductType.js";
import { BackDropLoading } from "../ui-component/BackDropLoading.js";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PinchToZoomAndPanImage from "../ui-component/PinchToZoomAndPanImage.js";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const MyHome = () => {
  const [listMenu, setListMenu] = useState([]);
  const [projectSelected, setProjectSelected] = useState("");
  const [projectList, setProjectList] = useState([]);
  const [houseNoList, setHouseNoList] = useState([]);
  const [houseNoSelected, setHouseNoSelected] = useState("");
  const [contractSelected, setContractSelected] = useState("");
  const [contractList, setContractList] = useState([]);
  const [unitTemp, setUnitTemp] = useState([]);
  const [isAlertSelected, setIsAlertSelected] = useState(false);
  const [profile, setProfile] = useState(null);
  const [imgAds, setImgAds] = useState([]);
  const [logoDefault, setLogoDefault] = useState(null);
  const [loadingImg, setLoadingImg] = useState(true);
  const [loadingMenu, setLoadingMenu] = useState(true);
  const [path, setPath] = useState({
    path: "",
    state: {},
  });
  const [disclaimerData, setDisclaimerData] = useState(null);
  const [description, setDescription] = useState("");
  const [isFunction, setIsFunction] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAlertDisclaimer, setIsAlertDisclaimer] = useState(false);
  const [checkDisclaimerLog, setCheckDisclaimerLog] = useState(false);
  const [showTextReminder, setShowTextReminder] = useState(false);

  let location = useLocation();
  let navigate = useNavigate();
  const theme = useTheme();
  const context = useContext(ProfileContext);
  const disclaimerlogContext = useContext(DisclaimerContext);

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      paritialVisibilityGutter: 60,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      paritialVisibilityGutter: 50,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      paritialVisibilityGutter: 30,
    },
  };

  const fetchListButtonMenu = async () => {
    const company_id = localStorage.getItem("cid") || localStorage.getItem("cid_pm") || localStorage.getItem("cid_rental");
    let response = await api.getListMenu({
      line_id: localStorage.getItem("userId"),
      company_id: company_id,
      is_rem: houseNoSelected.is_rem,
      is_pm: houseNoSelected.is_pm,
      is_rental: houseNoSelected.is_rental,
    });

    let menu = response.data?.menu;
    let alias = {
      billpaymentV2: {
        name: "",
        icon: <PaymentsRounded fontSize="medium" sx={{ color: "white" }} />,
        path: "/billpaymentV2",
      },
      billpayment: {
        name: "",
        icon: <PaymentsRounded fontSize="medium" sx={{ color: "white" }} />,
        path: "/billpayment",
      },
      installment: {
        name: "",
        icon: <PaymentsRounded fontSize="medium" sx={{ color: "white" }} />,
        path: "/billpayment",
      },
      parcel: {
        name: "",
        icon: <LocalShipping fontSize="medium" sx={{ color: "white" }} />,
        path: "/parcel",
      },
      phonebook: {
        name: "",
        icon: <ContactPhone fontSize="medium" sx={{ color: "white" }} />,
        path: "/phonebook",
      },
      phonebookrem: {
        name: "",
        icon: <ContactPhone fontSize="medium" sx={{ color: "white" }} />,
        path: "/phonebookrem",
      },
      facilities: {
        name: "",
        icon: <EventSeat fontSize="medium" sx={{ color: "white" }} />,
        path: "/facility",
      },
      loan: {
        name: "",
        icon: <MonetizationOn fontSize="medium" sx={{ color: "white" }} />,
        path: "/loan",
      },
      defect: {
        name: "",
        icon: <Handyman fontSize="medium" sx={{ color: "white" }} />,
        path: "/defect",
      },
      defectfast: {
        name: "",
        icon: <Handyman fontSize="medium" sx={{ color: "white" }} />,
        path: "/defectfast",
      },
      chatniti: {
        name: "",
        icon: <Forum fontSize="medium" sx={{ color: "white" }} />,
        path: "/chatniti",
      },
      contactsniti: {
        name: "",
        icon: <Contacts fontSize="medium" sx={{ color: "white" }} />,
        path: "/contactsniti",
      },
      addressdoc: {
        name: "",
        icon: <AddLocationAlt fontSize="medium" sx={{ color: "white" }} />,
        path: "/addressdoc",
      },
      regulations: {
        name: "",
        icon: <FactCheck fontSize="medium" sx={{ color: "white" }} />,
        path: "/regulations",
      },
      suggestion: {
        name: "",
        icon: <AddReactionOutlined fontSize="medium" sx={{ color: "white" }} />,
        path: "/suggestion",
      },
      equipment: {
        name: "",
        icon: (
          <EquipmentIcon
            style={{
              width: "1em",
              height: "1em",
              fontSize: "2rem",
              display: "inline-block",
            }}
            fill={"white"}
          />
        ),
        path: "/equipment",
      },
      defectdoc: {
        name: "",
        icon: (
          <ReportDefectIcon
            style={{
              width: "1em",
              height: "1em",
              fontSize: "2rem",
              display: "inline-block",
            }}
            fill={"white"}
          />
        ),
        path: "/defectdoc",
      },
      loancp: {
        name: "",
        icon: <MonetizationOn fontSize="medium" sx={{ color: "white" }} />,
        path: "/loancp",
      },
      inspectcp: {
        name: "",
        icon: (
          <ReportDefectIcon
            style={{
              width: "1em",
              height: "1em",
              fontSize: "2rem",
              display: "inline-block",
            }}
            fill={"white"}
          />
        ),
        path: "/inspectcp",
      },
      transfer: {
        name: "",
        icon: <DomainAdd fontSize="medium" sx={{ color: "white" }} />,
        path: "/transfercp",
      },
      manual: {
        name: "",
        icon: <AutoStories fontSize="medium" sx={{ color: "white" }} />,
        path: "/manualcp",
      },
      documents: {
        name: "",
        icon: <Description fontSize="medium" sx={{ color: "white" }} />,
        path: "/documents",
      },
      servicerequest: {
        name: "",
        icon: <Assignment  fontSize="medium" sx={{ color: "white" }}/>,
        path: "/line-oa/service-request/list"
      },
      servicerequestlist: {
        name: "",
        icon: <Assignment  fontSize="medium" sx={{ color: "white" }}/>,
        path: "/service-request/list"
      }
    };

    let list = [];

    menu.map((element) => {
      if (alias[element.alias]) {
        alias[element.alias].name = element.name;
        list.push(alias[element.alias]);
      }
    });

    setListMenu(list);
    setLoadingMenu(false);
    return;
  };

  const navigateByPath = async (path, state) => {
    let profile_lineOA = JSON.parse(localStorage.getItem("profile_lineOA"));
    let getCompanyId = profile_lineOA.cid
    setPath({ path: path, state: state });
    if (houseNoSelected === null) return setIsAlertSelected(true);
    let currentUrl = location.pathname.slice(1);
    let urlName = state.path.slice(1);
    let result = await api.middleWareDisclaimer({
      urlName: urlName,
      currentUrl: currentUrl,
      company_id: Number(getCompanyId) || Number(profile_lineOA.cid_pm) || Number(profile_lineOA.cid_rental),
    });
    if (!result || !result.data) {
      return navigate(path, { state: state });
    }

    let data = result?.data?.data;

    if (data === null || result?.data?.message === "disclaimer not found" || data?.status === "false") {
      return navigate(path, { state: state });
    }

    const isAcceptData = await api.getIsAcceptDisclaimer({
      company_id: Number(getCompanyId),
      line_id: profile_lineOA.profile.userId,
      master_disclaimer_id: result?.data?.data?.id,
      product_type: checkProductType(),
    })
    console.log(isAcceptData, "isAcceptData?.data?.data?.is_accept")

    //ถ้ามีการอัพเดทจาก back end web จะมีการโชว์ disclaimer
    if (data?.status === "true" && (data?.is_updated === true || isAcceptData.data?.data?.is_accept === false)) {
      setDescription(data.description);
      if (data.pictures && Array.isArray(data.pictures)) {
        data.pictures = data.pictures.map((picture) => ({
          id: picture.id ? picture.id.toString() : `new-${Math.random()}`,
          name: picture.name,
          url: picture.path,
        }));
      }
      setDisclaimerData(data);
      data.is_function ? setIsFunction(true) : setIsFunction(false);
      if (data.current_path === currentUrl && data.next_path === urlName) {
        setIsAlertDisclaimer(true);
      }
    } else {
      return navigate(path, { state: state });
    }
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) =>
        (prevIndex - 1 + disclaimerData.pictures.length) %
        disclaimerData.pictures.length
    );
  };

  const handleNext = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex + 1) % disclaimerData.pictures.length
    );
  };

  const selectHouseNo = () => {
    let temp = unitTemp;
    let houseNo = temp[projectSelected] || [];
    let defaultHouseNoSelected = sessionStorage.getItem("houseNoSelected");
    let storedContractId = sessionStorage.getItem("contractSelected");
    if (checkProductType() === "rental") {
      let noDuplicated = [];
      for (let i = 0; i < houseNo.length; i++) {
        if (
          !noDuplicated.some(
            (items) => items.unit_number == houseNo[i].unit_number
          )
        ) {
          const displayUnitNumber = houseNo[i].unit_number
          noDuplicated.push({
            ...houseNo[i],
            displayUnitNumber: displayUnitNumber,
          });
        }
      }
      houseNo = noDuplicated;
    }
    else{
      houseNo = houseNo.map((item) => {
        return {
          ...item,
          displayUnitNumber: item.house_number !== "" ? item.house_number : item.unit_number,
        }
      })
    }
    setHouseNoList(houseNo);

    // Find house number from session storage or default to first
    let houseNoSelected =
      houseNo?.find(
        (element) =>
          (element.house_number === ""
            ? element?.unit_number
            : element?.house_number) === defaultHouseNoSelected
      ) || houseNo[0];

    // Get contracts for selected house
    const contracts = houseNoSelected?.contract_numbers || [];

    // Find matching contract from stored contractId or default to first
    let contractSelected = contracts?.[0]; // Default to first contract
    if (storedContractId) {
      const matchingContract = contracts.find(
        (contract) => contract?.contract_id === storedContractId
      );
      // Only use stored contract if it belongs to current houseNoSelected
      if (matchingContract) {
        contractSelected = matchingContract;
      }
    }

    // Update states
    setHouseNoSelected(houseNoSelected);
    setContractList(contracts);
    setContractSelected(contractSelected);
  };

  const prepareList = (unit) => {
    setUnitTemp(unit);
    let unit_ProjectList = Object.keys(unit);
    setProjectList(unit_ProjectList);
  };

  const handleHouseNoSelected = () => {
    if (houseNoSelected === null || houseNoSelected === "") return;

    // Get stored contractSelected from sessionStorage
    const storedContractId = sessionStorage.getItem("contractSelected");
    const contracts = houseNoSelected?.contract_numbers || [];

    // Find matching contract from stored contractId
    let contractSelected = contracts?.[0]; // Default to first contract
    if (checkProductType() === "rental") {
      if (storedContractId) {
        const matchingContract = contracts?.find(
          (contract) => contract.contract_id === storedContractId
        );
        // Only use stored contract if it belongs to current houseNoSelected
        if (matchingContract) {
          contractSelected = matchingContract;
        }
      }

      const filterContractNumber = contracts.filter((contract, index) => {
      return contracts.findIndex(c => c.contract_number === contract.contract_number) === index;
      });

      // Set contract related states/storage
      sessionStorage.setItem("contractSelected", contractSelected?.contract_id);
      setContractList(filterContractNumber);
      setContractSelected(contractSelected);
    }

    // Update house info object and storage
    let objInfo = {
      ...houseNoSelected,
      contractSelected: contractSelected,
    };

    context.dispatch({
      type: SET_HOUSE_INFO,
      payload: objInfo,
    });

    sessionStorage.setItem(
      "houseNoSelected",
      houseNoSelected.house_number === ""
        ? houseNoSelected.unit_number
        : houseNoSelected.house_number
    );
    localStorage.setItem("houseInfoSelected", JSON.stringify(objInfo));
  };

  const handleContractSelected = (selectedContract) => {
    if (!selectedContract) return;

    // Update contract related states/storage
    sessionStorage.setItem("contractSelected", selectedContract?.contract_id);
    setContractSelected(selectedContract);

    // Update house info object with new selected contract
    let objInfo = {
      ...houseNoSelected,
      contractSelected: selectedContract,
    };

    context.dispatch({
      type: SET_HOUSE_INFO,
      payload: objInfo,
    });

    // Update localStorage with new house info
    localStorage.setItem("houseInfoSelected", JSON.stringify(objInfo));
  };

  const loadImg = async () => {
    let res = await api.getImageProjectList({
      line_id: profile?.line_id,
      product_type: unitTemp[projectSelected][0].product_type,
      project_id: unitTemp[projectSelected][0].project_id,
    });
    setImgAds(res.data?.data || []);
    setLoadingImg(false);
  };

  const imageCondition = () => {
    if (imgAds?.length > 0)
      return imgAds?.map((element, index) => (
        <div key={index} style={{ height: "270px" }}>
          <img
            src={element}
            style={{ objectFit: "cover", width: "100%", height: "100%" }}
          />
        </div>
      ));

    return (
      <div
        style={{
          height: "270px",
          backgroundColor: theme.palette.primary.main,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            backgroundImage: `url(${logoDefault})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% auto",
            backgroundPosition: "center",
            width: "200px",
            height: "200px",
          }}
        />
      </div>
    );
  };

  // comment เมื่อวันที่ 14/02/2024 useEffect(() => {

  //   if (houseNoList?.length > 0) {
  //     let house = houseNoList.find(ele => ele.house_number === sessionStorage.getItem("houseNoSelected"))
  //     setHouseNoSelected(house || null)
  //   }

  // }, [houseNoList])

  useEffect(() => {
    if (projectList.length > 0) {
      let defaultProjectSelected = sessionStorage.getItem("projectSelected");
      setProjectSelected(
        projectList.find((element) => element === defaultProjectSelected) ||
        projectList[0]
      );
    }
  }, [projectList]);

  useEffect(() => {
    if (projectSelected) {
      sessionStorage.setItem("projectSelected", projectSelected);
      selectHouseNo();
      setLoadingImg(true);
      loadImg();
    }
  }, [projectSelected]);

  useEffect(() => {
    if (houseNoSelected) {
      setLoadingMenu(true);
      fetchListButtonMenu();
    }
    handleHouseNoSelected();
  }, [houseNoSelected]);

  useEffect(() => {
    if (context.state?.profile?.unit == undefined) return;
    sessionStorage.setItem("tabSelected", "");
  }, []);

  useEffect(() => {
    if (context.state?.profile) {
      const languageError = context.state?.profile?.customer[0]?.language || "en";
      if (context.state?.profile?.customer.length === 0) {
        navigate("/noprofile", {
          state: {
            description: dict.No_Profile_TXT[languageError],
          }
        });
      }
      else if (Object.keys(context.state?.profile?.unit || {}).length === 0) {
        navigate("/noprofile", {
          state: {
            description: dict.No_Contract_TXT[languageError],
          }
        });
      }
    }

    if (context.state?.profile !== null) {
      setProfile(context.state?.profile?.customer[0]);
      setLogoDefault(context.state?.profile.logo);
      return prepareList(context.state?.profile.unit);
    }
  }, [context.state?.profile]);




  const isAcceptDisclaimerLog = async () => {
    let profile_lineOA = localStorage.getItem("profile_lineOA");
    let line_session = JSON.parse(profile_lineOA);
    let getCustomerName = JSON.parse(localStorage.getItem("houseInfoSelected"))

    let req = {
      master_disclaimer_id: disclaimerData?.id,
      user_id: line_session.profile.userId,
      accept_at: new Date(),
      username: getCustomerName.customer_name ? getCustomerName.customer_name : getCustomerName.customer_name_en,
      menu: disclaimerData.title,
      company_id: Number(line_session.cid) || Number(line_session.cid_pm) || Number(line_session.cid_rental),
    };

    disclaimerlogContext.dispatch({
      type: "SET_DISCLAIMER",
      payload: disclaimerData?.id,
    });
    await api
      .insertDisclaimerLog(req)
      .then((res) => {
        if (res?.status === 200) {
          api.updateDisclaimer({
            id: disclaimerData.id,
            accept_at: new Date(),
            is_updated: false,
            company_id: Number(line_session.cid) || Number(line_session.cid_pm) || Number(line_session.cid_rental),
          })
          return navigate(path.path, { state: path.state });
        }
      })
      .catch((err) => console.log(err));
  };

  const onClear = () => {
    setIsAlertDisclaimer(false);
    setShowTextReminder(false);
    setCheckDisclaimerLog(false);
  };

  return (
    <MasterPage>
      <Box sx={{ height: "200px", width: "100%" }}>
        <Carousel
          arrows={false}
          responsive={responsive}
          autoPlay={imgAds?.length === 0 ? false : true}
          autoPlaySpeed={10000}
          infinite={true}
        >
          {imageCondition()}
        </Carousel>
      </Box>
      <Container style={{ padding: "5%", transform: "translateY(-5%)" }}>
        <Card
          sx={{ borderRadius: "10px", boxShadow: "0px 0px 7px 0px #00000040" }}
        >
          <div
            style={{
              position: "absolute",
              left: "50%",
              transform: "translate(-50%,-140%)",
            }}
          >
            {projectSelected !== null && (
              <Box
                sx={{
                  backgroundColor: alpha(theme.palette.primary.main, 0.8),
                  borderRadius: "22px",
                  pl: "20px",
                  pt: "5px",
                  pb: "5px",
                  pr: "20px",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: theme.palette.primary.contrastText,
                    textWrap: "nowrap",
                  }}
                >
                  {projectSelected}
                </Typography>
              </Box>
            )}
            {/* <Chip variant='filled' color="secondary">{projectSelected}</Chip> */}
          </div>
          <Box sx={{ padding: "30px 20px 30px" }}>
            {/* 
            <Box sx={{
              display: "flex"
            }}>
              <Typography
                variant="body2"
                component="div"
              >
                {
                  dict.LabelSelectCondo_TXT[profile?.language]
                }
              </Typography>
            </Box> */}
            <FormControl sx={{ mb: 1, width: "100%" }} size="small">
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select-autowidth"
                value={projectSelected}
                sx={{ borderRadius: "5px", border: "1px" }}
                onChange={(event, val) => {
                  setProjectSelected(event.target.value);
                }}
              >
                {projectList?.map((element, i) => (
                  <MenuItem key={i} value={element}>
                    {element}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={{ width: "100%" }} size="small">
              <Select
                disabled={!projectSelected}
                value={houseNoSelected}
                sx={{ borderRadius: "5px", border: "1px" }}
                onChange={(event, val) => {
                  setHouseNoSelected(event.target.value);
                }}
              >
                {houseNoList?.map((element, i) => (
                  <MenuItem key={i} value={element}>
                    <Stack direction={"row"} alignItems="center" spacing={2}>
                      <Box>
                        {element.displayUnitNumber}
                      </Box>
                      {element?.product_type === "pmlite" && (
                        <Box>
                          <Chip
                            icon={<Done />}
                            size={"small"}
                            label={dict.Transfer_Owner_TXT[profile?.language]}
                          />
                        </Box>
                      )}
                    </Stack>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {checkProductType() === "rental" ? (
              <FormControl sx={{ mt: 1, width: "100%" }} size="small">
                <Select
                  disabled={!projectSelected || !houseNoSelected}
                  value={contractSelected || ""}
                  sx={{ borderRadius: "5px", border: "1px" }}
                  onChange={(event) => {
                    const selectedContract = event.target.value;
                    handleContractSelected(selectedContract);
                  }}
                >
                  {contractList?.map((element, i) => (
                    <MenuItem key={element.contract_id} value={element}>
                      <Stack direction="row" alignItems="center" spacing={2}>
                        <Box>{element.contract_number}</Box>
                        {element?.product_type === "pmlite" && (
                          <Box>
                            <Chip
                              icon={<Done />}
                              size="small"
                              label={dict.Transfer_Owner_TXT[profile?.language]}
                            />
                          </Box>
                        )}
                      </Stack>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : null}
          </Box>
        </Card>

        <Grid
          container
          mt={3}
          spacing={3}
          direction={"row"}
          alignItems="stretch"
        >
          {listMenu.length > 0 &&
            listMenu.map((element, index) => (
              <Grid
                item
                xs={4}
                key={index}
                onClick={(e) =>
                  navigateByPath(element.path + location.search, {
                    title: element.name,
                    path: element.path,
                  })
                }
              >
                {/* <Paper
                  style={{
                    borderRadius: "10px", boxShadow: "0px 0px 7px 0px #00000040",
                    minHeight: 110, textAlign: "center", display: "flex", justifyContent: "center"
                  }}
                  onClick={() => navigateByPath(element.path + location.search)}
                > */}
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent={"center"}
                  spacing={1}
                >
                  <div
                    style={{
                      height: "50px",
                      width: "50px",
                      textAlign: "center",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "center",
                      border: "1px",
                      boxShadow: "5px 5px 7px 0px #00000040",
                      borderRadius: 100,
                      backgroundColor: theme.palette.primary.main,
                    }}
                  >
                    <div style={{ marginTop: 5 }}>{element.icon}</div>
                  </div>

                  <Box sx={{ textAlign: "center" }}>
                    <Typography
                      variant="caption"
                      sx={{ wordWrap: "break-word" }}
                    >
                      {element.name.length > 19
                        ? element.name.substring(0, 15) + "..."
                        : element.name}
                    </Typography>
                  </Box>
                </Stack>
                {/* </Paper> */}
              </Grid>
            ))}
        </Grid>

        {isAlertDisclaimer && (
          <Modal open={isAlertDisclaimer} onClose={!isAlertDisclaimer}>
            <Box className="disclaimer-container">
              <Box
                className={`${disclaimerData.pictures.length > 0
                    ? "disclaimer-body-photo"
                    : "disclaimer-body-photo-hidden"
                  }`}
              >
                {/* <img
                  alt={disclaimerData.pictures[currentIndex]?.name}
                  src={
                    disclaimerData.pictures.length > 0
                      ? disclaimerData.pictures[currentIndex].url
                      : ""
                  }
                  style={{
                    width: "310px",
                    height: "630px",
                    objectFit: "cover",
                    maxWidth: "100%",
                    maxHeight: "100%",
                  }}
                /> */}
                <div style={{ overflow: "scroll", width: "100%", height: "100%" }}>
                  <PinchToZoomAndPanImage
                    src={disclaimerData?.pictures?.length > 0
                      ? disclaimerData.pictures[currentIndex].url
                      : ""}
                  />
                </div>
                <ChevronLeftIcon
                  onClick={handlePrev}
                  style={{
                    fontSize: "30px",
                    color: "#fff",
                    cursor: "pointer",
                    backgroundColor: "rgb(25, 148, 106)",
                    borderRadius: "50%",
                    position: "absolute",
                    left: 0,
                    top: "50%"
                  }}
                />
                <ChevronRightIcon
                  onClick={handleNext}
                  style={{
                    fontSize: "30px",
                    color: "#fff",
                    cursor: "pointer",
                    backgroundColor: "rgb(25, 148, 106)",
                    borderRadius: "50%",
                    position: "absolute",
                    right: 0,
                    top: "50%"
                  }}
                />
              </Box>
              <Box className="disclaimer-body-container">
                <p className="disclaimer-body-text">{description}</p>

                <div hidden={isFunction ? false : true}>
                  <Checkbox
                    style={{
                      marginLeft: "1.5rem",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    onClick={(e) => {
                      if (e.target.checked) {
                        setCheckDisclaimerLog(true);
                      } else {
                        return null;
                      }
                    }}
                    disabled={checkDisclaimerLog ? true : false}
                  />
                  ตกลงและยอมรับเงื่อนไข
                </div>
                {showTextReminder && (
                  <p
                    style={{
                      color: "red",
                      marginLeft: "1.5rem",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    *กรุณายอมรับเงื่อนไขก่อน
                  </p>
                )}
                <div className="disclaimer-body-footer">
                  <div
                    className="button-container"
                    hidden={isFunction ? false : true}
                  >
                    <Button
                      onClick={() => onClear()}
                      style={{
                        backgroundColor: "white",
                        color: "#19946a",
                        border: "1px solid #19946a",
                        marginRight: "1rem",
                      }}
                    >
                      ยกเลิก
                    </Button>
                    <Button
                      onClick={() => {
                        if (checkDisclaimerLog) {
                          isAcceptDisclaimerLog();
                        } else {
                          setShowTextReminder(true);
                        }
                      }}
                      style={{
                        backgroundColor: "green",
                        color: "white",
                        border: "1px solid #19946a",
                      }}
                    >
                      ยืนยัน
                    </Button>
                  </div>
                  <div
                    hidden={isFunction ? true : false}
                    className="button-container"
                  >
                    <Button
                      onClick={() => {
                        let disclaimerIdIsExist =
                          disclaimerlogContext.state?.id.find(
                            (ele) => ele === disclaimerData?.data?.id
                          );
                        if (disclaimerIdIsExist) {
                          return navigate(path.path, { state: path.state });
                        } else {
                          disclaimerlogContext.dispatch({
                            type: "SET_DISCLAIMER",
                            payload: disclaimerData?.id,
                          });
                        }
                      }}
                      type="primary"
                      style={{
                        backgroundColor: "green",
                        color: "white",
                        border: "1px solid #19946a",
                      }}
                    >
                      ปิด
                    </Button>
                  </div>
                </div>
              </Box>
            </Box>
          </Modal>
        )}

        <Snackbar
          open={isAlertSelected}
          autoHideDuration={6000}
          onClose={() => setIsAlertSelected(false)}
        >
          <Alert
            onClose={() => setIsAlertSelected(false)}
            severity="info"
            sx={{ width: "100%" }}
          >
            {dict.Fill_Name_HouseNumber_TXT[profile?.language]}
          </Alert>
        </Snackbar>
      </Container>
      <BackDropLoading loading={loadingImg || loadingMenu} />
    </MasterPage>
  );
};
